import { defineStore } from 'pinia'
import { apiService } from '@/services/api'

export const useSystemInfoStore = defineStore('systemInfo', {
  state: () => ({
    systemInfos: [],
    formData: null,
    tableList: [],
  }),
  actions: {
    // システム情報を取得
    async getSystemInfo() {
      try {
        const response = await apiService.get('/api/system-infos')
        this.systemInfos = response.systemInfos
      } catch (error) {}
    },
    // テーブル表示用のリストを初期化
    initTableList() {
      // No、お知らせ日付、タイトル、内容、重要度
      this.tableList = [
        { label: 'No', key: 'rowNumber', data: (item, value) => value },
        { label: 'お知らせ日付', key: 'date', data: (item, value) => value },
        {
          label: '重要度',
          key: 'isImportant',
          data: (item, value) => (value ? '重要' : '通常'),
          tag: {
            重要: 'application-in-progress',
            通常: 'unattended',
          },
        },
        { label: 'タイトル', key: 'title', data: (item, value) => value },
        {
          label: '内容',
          key: 'text',
          data: (item, value) => {
            return value?.length > 20 ? value.substring(0, 20) + '...' : value
          },
        },
      ]
    },
    // フォームデータ設定
    setFormData(id) {
      if (!id) return
      const systemInfo = this.systemInfos.find(item => item.id === id)
      if (systemInfo) {
        this.formData = JSON.parse(JSON.stringify(systemInfo))
      }
    },
  },
})
